<template>

	<page >
		<title-view>{{ $t('attributes.screen')}}
			<template v-if="$route.matched.some(({ name }) => name === 'surveyors-page')" >{{$t('pages.orderFilter.survyers')}}</template>
			<template v-else-if="$route.matched.some(({ name }) => name === 'users-page')">
				{{$t('attributes.users')}}
			</template>
			<template v-else>
				{{$t('attributes.userCustomers')}}
			</template>
			<v-btn slot="actions" @click="onEdit({})" color="success">{{$t('attributes.add')}} {{$t('attributes.user')}}</v-btn>
		</title-view>
		<row>
			<c-col>
				<users-table :hide-search="filters" @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">{{$t('attributes.addOrEdit')}} {{namePage}}</span>
			<user-form @save="openModal=false" :type="type"/>
		</popup-dialog>

	</page>

</template>

<script>
	import UserForm from "src/view/users/UserForm";
	import UsersTable from "src/view/users/UsersTable";
	import UserModule from "src/store/modules/User.module";
	import {types as rolesTypes} from "dev/helpers/RoleManager";


	export default {
		name: "users-view",
		components: { UsersTable, UserForm },
		props:["type"],
		data () {
			return {
				openModal: false
			};
		},
		computed:{
			filters() {
				return (this.type === rolesTypes.OFFICERS) ? {roles: [5, 6, 7, 8]} : {role: this.type};
			},
			namePage(){

				if (this.type===rolesTypes.SURVEYORS)
					return this.$t("pages.orderFilter.survyers");
				if (this.type===rolesTypes.OFFICERS)
					return this.$t("attributes.Receptionist");
				else return this.$t("attributes.users");
			}

		},
		methods: {
			onEdit (user) {
				if (user.id) {
					this.$store.commit(UserModule.types.GET, user);
				}else {
					this.$store.commit(UserModule.types.CREATE, {role:this.type});

				}
				this.openModal = true;
			}
		}

	};
</script>

<style scoped>

</style>
